export default "__VITE_ASSET__COUyAVtB__"